import { render } from "./ChatMessageBlock.vue?vue&type=template&id=bb8010f2&scoped=true"
import script from "./ChatMessageBlock.vue?vue&type=script&lang=js"
export * from "./ChatMessageBlock.vue?vue&type=script&lang=js"

import "./ChatMessageBlock.vue?vue&type=style&index=0&id=bb8010f2&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb8010f2"]])

export default __exports__